import {
  AlertCircle,
  FileText,
  MessageSquare,
  DollarSign,
  Star,
} from "@semo/icons";
import type { NotificationResponseDto } from "@semo/api-contracts";

export function getTimeAgo(date: string | Date): string {
  const now = new Date();
  const past = typeof date === "string" ? new Date(date) : date;
  const diffMs = now.getTime() - past.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 60) return `${diffMins}분 전`;
  if (diffHours < 24) return `${diffHours}시간 전`;
  return `${diffDays}일 전`;
}

export const convertNotificationToDisplay = (
  notification: NotificationResponseDto,
) => {
  // category 한글 매핑
  const categoryNameMap: Record<string, string> = {
    system: "시스템",
    project: "프로젝트",
    chat: "채팅",
    payment: "결제",
    review: "리뷰",
  };

  // category에 따른 icon과 color 결정
  const getIconAndColor = (category: string) => {
    switch (category) {
      case "system":
        return {
          icon: AlertCircle,
          color: "bg-gradient-to-br from-slate-500 to-slate-600",
        };
      case "project":
        return {
          icon: FileText,
          color: "bg-gradient-to-br from-primary to-primary-hover",
        };
      case "chat":
        return {
          icon: MessageSquare,
          color: "bg-gradient-to-br from-green-500 to-green-600",
        };
      case "payment":
        return {
          icon: DollarSign,
          color: "bg-gradient-to-br from-purple-500 to-purple-600",
        };
      case "review":
        return {
          icon: Star,
          color: "bg-gradient-to-br from-orange-500 to-orange-600",
        };
      default:
        return {
          icon: AlertCircle,
          color: "bg-gradient-to-br from-slate-500 to-slate-600",
        };
    }
  };

  const { icon, color } = getIconAndColor(notification.category);

  return {
    id: notification.id,
    type: categoryNameMap[notification.category] || notification.category,
    title: notification.title,
    content: notification.message,
    time: getTimeAgo(notification.createdAt),
    isRead: notification.isRead,
    icon,
    color,
    notificationId: notification.id,
    resourceType: notification.resourceType,
    resourceId: notification.resourceId,
  };
};
